import React from "react";
import ColonneTabellaPanel from "../../../interfaccia/colonneTabella/ColonneTabellaPanel";
import { ORDINI_COLUMN_IDS, ORDINI_COLUMN_METADATA, ORDINI_LOCKED_COLUMN_IDS } from "./ordiniColumnMetadata";

export default function ColonneOrdiniPanel(props) {
  return <ColonneTabellaPanel {...props}
    metadata={ORDINI_COLUMN_METADATA} columnIds={ORDINI_COLUMN_IDS} lockedIds={ORDINI_LOCKED_COLUMN_IDS}
    idPrefix="ordini-colonne" ariaLabel="Colonne della tabella ordini" selectionColumn />;
}
